import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import AppContext from '../../../Context/AppContext';
import currentUserStep from '../../../util/currentUserStep';
import {
    enablePortalV2Session,
    resolveNonSubscriberPath,
    resolveNonSubscriberPathV2,
    resolveUserStepPathV2,
    isPortalV2Enabled,
} from '../../../util/portalV2';
import { isNativeApp } from '../../../util/capacitorNative';
import { isNativeLiteAppMode } from '../../../util/appMode';
import './UsanaLogin.css';
import SsoHandoffV2 from '../../PortalV2/Auth/SsoHandoffV2';

const UsanaLogin = () => {
    const {
        loginWithUsanaToken,
        changeLoading,
    } = useContext(AppContext);
    const history = useHistory();

    useEffect(() => {
        const handleLoginWithToken = async () => {
            // Extraer el token directamente de la URL sin que React Router lo decodifique
            const pathParts = window.location.pathname.split('/');
            const tokenFromUrl = pathParts[pathParts.length - 1];
            
            if (!tokenFromUrl || tokenFromUrl === 'UsanaLogin') {
                history.push(isNativeApp() || isPortalV2Enabled() ? '/login-v2' : '/login');
                return;
            }

            // Decodificar el token de la URL (convierte %2F a /, %2B a +, etc.)
            // Usar try-catch en caso de que el navegador ya haya decodificado parcialmente
            let decodedToken;
            try {
                decodedToken = decodeURIComponent(tokenFromUrl);
            } catch (e) {
                // Si falla la decodificación, usar el token tal como está
                decodedToken = tokenFromUrl;
            }
            
            changeLoading(true);
            const userStep = await loginWithUsanaToken(decodedToken);
            
            if (userStep?.data == null) {
                // Login exitoso
                if (userStep || userStep === 0) {
                    changeLoading(false);
                    const useV2 = isNativeApp() || isPortalV2Enabled();
                    if (useV2) {
                        enablePortalV2Session();
                    }
                    if (userStep === -1) {
                        history.push(
                            useV2
                                ? resolveNonSubscriberPathV2()
                                : resolveNonSubscriberPath()
                        );
                    } else if (isNativeLiteAppMode()) {
                        history.push('/dashboard-v2');
                    } else if (useV2) {
                        history.push(resolveUserStepPathV2(userStep));
                    } else {
                        history.push(currentUserStep(userStep));
                    }
                }
            } else {
                // Error en el login
                changeLoading(false);
                history.push(
                    isNativeApp() || isPortalV2Enabled()
                        ? '/login-v2?error=auth_failed'
                        : '/login?error=auth_failed'
                );
            }
        };

        handleLoginWithToken();
    }, [history, loginWithUsanaToken, changeLoading]);

    return isPortalV2Enabled() || isNativeApp() ? (
        <SsoHandoffV2 title="Signing you in" />
    ) : null;
};

export default UsanaLogin;
